import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import MySelect from "./MySelect";
import ShowHideSelect from "./ShowHideSelect";
import Checkbox from "./Checkbox";
import MyDatePicker from "./DatePicker";
import Button from "./Button";
import ActionButton from "./ActionButton";


import PremiumButton from "./PremiumButton";


const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    MyDatePicker,
    Button,
    ActionButton,
    MySelect,
    ShowHideSelect,
    PremiumButton
}

export default Controls;